module.exports = __webpack_public_path__ + "img/calendar-solid-light.4c40bf63.svg";